import PackagingDetail from './packagingDetail';
export default PackagingDetail;